import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { ItemService } from './item-service';
import { DonneesBaseService } from './donnees-base-service';
import { BonTravailEntite } from '../entites/mecanique/bon-travail';
import { RequeteAjouterEtapesBonTravail } from './requetes/requete-ajouter-etapes-bon-travail';
import { ReponseAjouterEtapesBonTravail } from './reponses/reponse-ajouter-etapes-bon-travail';
import { MajService } from './maj-service';
import { RequeteCreerBonTravailPartiel } from './requetes/requete-creer-bon-travail-partiel';
import { BaseService } from './base.service';
import { MessageService } from 'primeng/api';
import { RequeteApprobationSoumission } from './requetes/requete-approbation-soumission';
import { ReleveHeureEntite } from '../entites/releve-heures';
import { ReleveKmEntite } from '../entites/releve-kms';
import { ItemBonCommande } from '../entites/item-bon-commande';
import { RequeteAjouterAnalyseBonTravail } from './requetes/requete-approuver-bontravail';
import { AnalyseBonTravail } from '../entites/analyse-bon-travail';
import { ReponseAjouterAnalyseBonTravail } from './reponses/reponse-ajouter-analyse-bon-travail';
import { HubConnection } from '@microsoft/signalr';
import { SihcHubService, SihcEvents } from './sihc-hub.service';
import { Injectable } from '@angular/core';
import { CacheMap, SignalWithWatcher } from './base.service';
import { enrichirRechercheEmploye } from '../entites/employe';

@Injectable({ providedIn: 'root' })
export class BonTravailService extends BaseService {

  private obtenirUrl = environment.apiBaseUrl + 'bontravail';
  private obtenirSoumissionsUrl = environment.apiBaseUrl + 'bontravail/soumissions';
  private obtenirParItemUrl = environment.apiBaseUrl + 'bontravail/item/{id}';
  private obtenirItemBonCommandeAssocieUrl = environment.apiBaseUrl + 'bontravail/{id}/itemboncommande';
  private obtenirOuvertsParItemUrl = environment.apiBaseUrl + 'bontravail/item/{id}/ouverts';
  private detailUrl = environment.apiBaseUrl + 'bontravail/{id}';
  private creerUrl = environment.apiBaseUrl + 'bontravail';
  private modifierUrl = environment.apiBaseUrl + 'bontravail/modifier';
  private modifierBonTravailAutoUrl = environment.apiBaseUrl + 'bontravail/modifier/auto';
  private envoyerapprobationUrl = environment.apiBaseUrl + 'bontravail/envoyerapprobation';
  private envoyerapprobationSoumissionUrl = environment.apiBaseUrl + 'bontravail/{id}/envoyerapprobationSoumission';
  private completerUrl = environment.apiBaseUrl + 'bontravail/completer';
  private supprimerUrl = environment.apiBaseUrl + 'bontravail/{id}';
  private ajouterEtapesUrl = environment.apiBaseUrl + 'bontravail/etapes';
  private annulerEPUrl = environment.apiBaseUrl + 'bontravail/supprimerentretiencomplete/{etapeId}';
  private creerPartielUrl = environment.apiBaseUrl + 'bontravail/creerpartiel';
  private convertirEtapeBonTravailToManuelUrl = environment.apiBaseUrl + 'bontravail/convertiretapebontravailtomanuel/{etapeId}';
  private transformerSoumissionUrl = environment.apiBaseUrl + 'bontravail/transformersoumission';
  private obtenirAnalysesUrl = environment.apiBaseUrl + 'bontravail/analyses';
  private obtenirAnalyseBonTravailUrl = environment.apiBaseUrl + 'bontravail/analyse/{id}';
  private modifierAnalyseBonTravailUrl = environment.apiBaseUrl + 'bontravail/analyse';
  private ajouterAnalyseBonTravailUrl = environment.apiBaseUrl + 'bontravail/analyse';
  private checkMechanicExistsUrl = environment.apiBaseUrl + 'bontravail/checkmecanicien/{noEmploye}';
  private modifierChampUrl = environment.apiBaseUrl + 'bontravail/{id}/champ';
  private modifierEtapeUrl = environment.apiBaseUrl + 'bontravail/etapes/{etapeId}';
  private reordonnerEtapesUrl = environment.apiBaseUrl + 'bontravail/{id}/etapes/ordre';
  private supprimerEtapesUrl = environment.apiBaseUrl + 'bontravail/{id}/etapes';
  private ajouterPieceUrl = environment.apiBaseUrl + 'bontravail/etapes/{etapeId}/pieces';
  private modifierPieceUrl = environment.apiBaseUrl + 'bontravail/pieces/{pieceId}';
  private supprimerPieceUrl = environment.apiBaseUrl + 'bontravail/pieces/{pieceId}';
  private lierReleveUrl = environment.apiBaseUrl + 'bontravail/{id}/lier-releve';
  private delierReleveUrl = environment.apiBaseUrl + 'bontravail/{id}/delier-releve';
  private relevesItemUrl = environment.apiBaseUrl + 'bontravail/{id}/releves-item';
  private upsertOptionUrl = environment.apiBaseUrl + 'bontravail/etapes/{etapeId}/options';
  private supprimerOptionUrl = environment.apiBaseUrl + 'bontravail/options/{optionId}';
  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  private hubConnection: HubConnection;
  private bonsTravailCache = new CacheMap<string, SignalWithWatcher<BonTravailEntite[]>>(2);

  constructor(
    private majService: MajService,
    public sdb: DonneesBaseService,
    public itemService: ItemService,
    public http: HttpClient,
    public router: Router,
    public messageService: MessageService,
    private bonTravailHub: SihcHubService
  ) {
    super(messageService, router);
    this.hubConnection = this.bonTravailHub.connection;
    void this.bonTravailHub.subscribe('bontravails');

    this.Obtenir(false).subscribe();
  }

  public Obtenir(indSoumission: boolean = false): Observable<SignalWithWatcher<BonTravailEntite[]>> {
    return this.http.get<BonTravailEntite[]>(this.obtenirUrl + (indSoumission ? '?indSoumission=true' : ''))
    .pipe(
      catchError(error => this.handleError(error))
    )
    .watchUpdates({
      hub: {
        hubConnection: this.hubConnection,
        idField: 'bonTravailId',
        events: { add: SihcEvents.bonTravailsAdd, update: SihcEvents.bonTravailsUpdate, delete: SihcEvents.bonTravailsDelete }
      },
      caching: {
        key: (indSoumission ? 'soumissions' : 'bontravails'),
        cacheMap: this.bonsTravailCache
      },
      transformFunction: (data) => this.enrichirRechercheEmployes(data)
    });
  }

  /**
   * Enrichit les employés d'un bon de travail avec les champs de recherche dérivés
   * (initiales, prenomNom, recherche) pour permettre le filtrage par initiales et nom complet.
   */
  private enrichirRechercheEmployeBonTravail(bt: BonTravailEntite): BonTravailEntite {
    if (!bt) {
      return bt;
    }
    enrichirRechercheEmploye(bt.contreMaitre);
    enrichirRechercheEmploye(bt.mecanicien);
    bt.etapes?.forEach(etape => enrichirRechercheEmploye(etape.mecanicien));
    return bt;
  }

  /**
   * Enrichit les employés des bons de travail avec les champs de recherche dérivés
   * (initiales, prenomNom, recherche) pour permettre le filtrage par initiales.
   * Appliqué au chargement initial comme aux mises à jour SignalR.
   */
  private enrichirRechercheEmployes(data: BonTravailEntite[]): BonTravailEntite[] {
    data?.forEach(bdt => this.enrichirRechercheEmployeBonTravail(bdt));
    return data;
  }

  public ObtenirParItem(id: number): Promise<ReponseBase<BonTravailEntite[]>> {
    var p = this.http.get<ReponseBase<BonTravailEntite[]>>(this.obtenirParItemUrl.replace('{id}', id.toString()))
      .toPromise();
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public ObtenirOuvertsParItem(id: number): Promise<ReponseBase<BonTravailEntite[]>> {
    var p = this.http.get<ReponseBase<BonTravailEntite[]>>(this.obtenirOuvertsParItemUrl.replace('{id}', id.toString()))
      .toPromise();
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }


  public ObtenirDetail(id: number): Observable<SignalWithWatcher<BonTravailEntite>> {
    return this.http.get<BonTravailEntite>(this.detailUrl.replace('{id}', id.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'bonTravailId',
          events: { add: SihcEvents.bonTravailsAdd, update: SihcEvents.bonTravailsUpdate, delete: SihcEvents.bonTravailsDelete }
        },
        transformFunction: (data) => this.enrichirRechercheEmployeBonTravail(data)
      });
  }

  public ObtenirItemBonCommandeAssocie(id: number, dateDebut: Date, dateFin: Date): Observable<HttpResponse<ItemBonCommande[]>> {
    const url = `${this.obtenirItemBonCommandeAssocieUrl.replace('{id}', id.toString())}?dateDebut=${dateDebut.toISOString()}&dateFin=${dateFin.toISOString()}`;
    return this.http.get<ItemBonCommande[]>(url, { observe: 'response' });
  }

  public Creer(entretien: BonTravailEntite): Promise<ReponseBase<BonTravailEntite>> {
    var p = this.http.post<ReponseBase<BonTravailEntite>>(this.creerUrl, JSON.stringify(this.avecRelevesLegers(entretien)), this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public TransformerSoumission(entretien: BonTravailEntite): Promise<ReponseBase<BonTravailEntite>> {
    var p = this.http.post<ReponseBase<BonTravailEntite>>(this.transformerSoumissionUrl, JSON.stringify(this.avecRelevesLegers(entretien)), this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public Modifier(entretien: BonTravailEntite): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(this.modifierUrl, JSON.stringify(entretien), this.httpOptions)
    .pipe(
      tap(_ => this.majService.Traiter())
    );
  }

  public ModifierBonTravailAuto(bonTravail: BonTravailEntite): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(this.modifierBonTravailAutoUrl, JSON.stringify(bonTravail), this.httpOptions)
      .pipe(
        tap(_ => this.majService.Traiter())
      );
  }

  public EnvoyerApprobationSoumission(id: number, requete: RequeteApprobationSoumission): Observable<HttpResponse<void>> {
    var p = this.http.post<void>(this.envoyerapprobationSoumissionUrl.replace('{id}', id.toString()), JSON.stringify(requete), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' })
    return p;
  }

  public EnvoyerApprobation(entretien: BonTravailEntite): Promise<ReponseBase<BonTravailEntite>> {
    var p = this.http.post<ReponseBase<BonTravailEntite>>(this.envoyerapprobationUrl, JSON.stringify(this.avecRelevesLegers(entretien)), this.httpOptions)
      .toPromise();
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public Completer(bonTravail: BonTravailEntite): Promise<ReponseBase<BonTravailEntite>> {
    var p = this.http.post<ReponseBase<BonTravailEntite>>(this.completerUrl, JSON.stringify(this.avecRelevesLegers(bonTravail)), this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public CreerPartiel(requete: RequeteCreerBonTravailPartiel): Promise<ReponseBase<string>> {
    var p = this.http.post<ReponseBase<string>>(this.creerPartielUrl, JSON.stringify(requete), this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public AjouterEtapes(requete: RequeteAjouterEtapesBonTravail): Promise<ReponseBase<ReponseAjouterEtapesBonTravail>> {
    var p = this.http.post<ReponseBase<ReponseAjouterEtapesBonTravail>>(this.ajouterEtapesUrl, JSON.stringify(requete), this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  public AnnulerEntretienPreventifComplete(etapeId: number): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.annulerEPUrl.replace('{etapeId}', etapeId.toString()), null, this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  /**
   * Obtenir les analyses de bon de travail
   * @returns Une Observable contenant une liste d'analyses de bon de travail
   */
  public ObtenirAnalyses(): Observable<HttpResponse<AnalyseBonTravail[]>> {
    return this.http.get<AnalyseBonTravail[]>(this.obtenirAnalysesUrl, { observe: 'response' });
  }

  public ObtenirAnalyseBonTravail(id: number): Observable<HttpResponse<AnalyseBonTravail>> {
    return this.http.get<AnalyseBonTravail>(this.obtenirAnalyseBonTravailUrl.replace('{id}', id.toString()), { observe: 'response' });
  }

  public ModifierAnalyseBonTravail(analyse: AnalyseBonTravail): Observable<HttpResponse<AnalyseBonTravail>> {
    return this.http.put<AnalyseBonTravail>(this.modifierAnalyseBonTravailUrl, JSON.stringify(analyse), {...this.httpOptions, observe: 'response'});
  }

  public AjouterAnalyseBonTravail(requete: RequeteAjouterAnalyseBonTravail): Observable<HttpResponse<ReponseAjouterAnalyseBonTravail>> {
    return this.http.post<ReponseAjouterAnalyseBonTravail>(this.ajouterAnalyseBonTravailUrl, JSON.stringify(requete), {...this.httpOptions, observe: 'response'});
  }

  public CheckMechanicExists(noEmploye: string): Observable<HttpResponse<void>> {
    return this.http.get<void>(this.checkMechanicExistsUrl.replace('{noEmploye}', noEmploye), { observe: 'response' });
  }

  /**
   * This method is used to convert a work order step to manual.
   * It sends a POST request to the server with the ID of the work order step that needs to be converted.
   * If the server response is successful, it triggers the majService to process the changes.
   * If the server response is not successful, it redirects the user to the error page.
   *
   * @param {number} etapeId - The ID of the work order step that needs to be converted to manual.
   * @returns {Promise<ReponseBase<number>>} A Promise that resolves with the server response.
   */
  public ConvertirEtapeBonTravailToManuel(etapeId: number): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.convertirEtapeBonTravailToManuelUrl.replace('{etapeId}', etapeId.toString()), null, this.httpOptions)
      .toPromise();
    p.then(() => this.majService.Traiter());
    p.catch(() => this.router.navigateByUrl('error'));
    return p;
  }

  /**
   * Patches a single header field.
   */
  public ModifierChamp(id: number, champ: string, valeur: any): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.patch<ReponseBase<BonTravailEntite>>(
      this.modifierChampUrl.replace('{id}', id.toString()),
      JSON.stringify({ champ, valeur }),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Patches a single étape field.
   */
  public ModifierEtapeChamp(etapeId: number, champ: string, valeur: any): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.patch<ReponseBase<BonTravailEntite>>(
      this.modifierEtapeUrl.replace('{etapeId}', etapeId.toString()),
      JSON.stringify({ champ, valeur }),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Persists étape order.
   */
  public ReordonnerEtapes(id: number, orderedIds: number[]): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.put<ReponseBase<BonTravailEntite>>(
      this.reordonnerEtapesUrl.replace('{id}', id.toString()),
      JSON.stringify({ orderedIds }),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Deletes étapes by id.
   */
  public SupprimerEtapes(id: number, etapeBonTravailIds: number[]): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.request<ReponseBase<BonTravailEntite>>(
      'DELETE',
      this.supprimerEtapesUrl.replace('{id}', id.toString()),
      { body: JSON.stringify({ etapeBonTravailIds }), headers: this.httpOptions.headers }
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Adds a pièce under an étape.
   */
  public AjouterPiece(etapeId: number, requete: { itemId: number; quantite: string; note?: string }): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(
      this.ajouterPieceUrl.replace('{etapeId}', etapeId.toString()),
      JSON.stringify(requete),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Updates a pièce.
   */
  public ModifierPiece(pieceId: number, requete: { itemId?: number; quantite: string; note?: string }): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.patch<ReponseBase<BonTravailEntite>>(
      this.modifierPieceUrl.replace('{pieceId}', pieceId.toString()),
      JSON.stringify(requete),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Deletes a pièce.
   */
  public SupprimerPiece(pieceId: number): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.delete<ReponseBase<BonTravailEntite>>(
      this.supprimerPieceUrl.replace('{pieceId}', pieceId.toString())
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Liste les relevés approuvés de l'unité d'un bon de travail pour sélection,
   * avec indication de leur association éventuelle à un bon de travail.
   * @param id Identifiant du bon de travail.
   * @param type 'heure' ou 'km'.
   */
  public ObtenirRelevesItemHeure(id: number): Observable<ReponseBase<ReleveHeureEntite[]>> {
    return this.http.get<ReponseBase<ReleveHeureEntite[]>>(
      `${this.relevesItemUrl.replace('{id}', id.toString())}?type=heure`
    ).pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Liste les relevés de KM approuvés de l'unité d'un bon de travail pour sélection.
   * @param id Identifiant du bon de travail.
   */
  public ObtenirRelevesItemKm(id: number): Observable<ReponseBase<ReleveKmEntite[]>> {
    return this.http.get<ReponseBase<ReleveKmEntite[]>>(
      `${this.relevesItemUrl.replace('{id}', id.toString())}?type=km`
    ).pipe(catchError(error => this.handleError(error)));
  }

  /**
   * Lie un relevé existant à un bon de travail (début ou fin).
   * @param id Identifiant du bon de travail.
   * @param cote 'debut' ou 'fin'.
   * @param type 'heure' ou 'km'.
   * @param releveId Identifiant du relevé à lier.
   */
  public LierReleve(id: number, cote: 'debut' | 'fin', type: 'heure' | 'km', releveId: number): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(
      this.lierReleveUrl.replace('{id}', id.toString()),
      JSON.stringify({ cote, type, releveId }),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Délie le relevé d'un bon de travail (début ou fin).
   * @param id Identifiant du bon de travail.
   * @param cote 'debut' ou 'fin'.
   * @param type 'heure' ou 'km'.
   */
  public DelierReleve(id: number, cote: 'debut' | 'fin', type: 'heure' | 'km'): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(
      this.delierReleveUrl.replace('{id}', id.toString()),
      JSON.stringify({ cote, type }),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Creates or updates a soumission option.
   */
  public UpsertOption(etapeId: number, requete: any): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.post<ReponseBase<BonTravailEntite>>(
      this.upsertOptionUrl.replace('{etapeId}', etapeId.toString()),
      JSON.stringify(requete),
      this.httpOptions
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * Deletes a soumission option.
   */
  public SupprimerOption(optionId: number): Observable<ReponseBase<BonTravailEntite>> {
    return this.http.delete<ReponseBase<BonTravailEntite>>(
      this.supprimerOptionUrl.replace('{optionId}', optionId.toString())
    ).pipe(tap(_ => this.majService.Traiter()), catchError(error => this.handleError(error)));
  }

  /**
   * N'envoie que les identifiants des relevés liés, sans le graphe item/employé.
   */
  private avecRelevesLegers(bonTravail: BonTravailEntite): BonTravailEntite {
    return {
      ...bonTravail,
      releveHeureDebut: this.releveHeureLeger(bonTravail.releveHeureDebut),
      releveHeureFin: this.releveHeureLeger(bonTravail.releveHeureFin),
      releveKmDebut: this.releveKmLeger(bonTravail.releveKmDebut),
      releveKmFin: this.releveKmLeger(bonTravail.releveKmFin)
    };
  }

  /**
   * Réduit un relevé d'heures à son identifiant (et valeurs utiles).
   */
  private releveHeureLeger(releve?: ReleveHeureEntite): ReleveHeureEntite | undefined {
    return releve?.releveHeureId
      ? { releveHeureId: releve.releveHeureId, date: releve.date, nbHeure: releve.nbHeure }
      : undefined;
  }

  /**
   * Réduit un relevé de KM à son identifiant (et valeurs utiles).
   */
  private releveKmLeger(releve?: ReleveKmEntite): ReleveKmEntite | undefined {
    return releve?.releveKmId
      ? { releveKmId: releve.releveKmId, date: releve.date, nbKm: releve.nbKm }
      : undefined;
  }
}
